import { render, staticRenderFns } from "./CollectingTranscript.vue?vue&type=template&id=65f94d8e&scoped=true&"
import script from "./CollectingTranscript.vue?vue&type=script&lang=js&"
export * from "./CollectingTranscript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f94d8e",
  null
  
)

export default component.exports